import React, { useState, useEffect, useRef } from "react";
import styles from "./MediaFilter.module.css";
import i18n from "../../Services/i18n";

const MediaFilter = ({ folder, refreshFolderPreview, services }) => {
  const [nameContains, setNameContains] = useState("");
  const [selectedService, setSelectedService] = useState(null);

  const effectRan = useRef(false);

  useEffect(() => {
    if (effectRan.current) {
      const filterObj = {
        folderUId: folder?.folderUId,
        nameContains,
        serviceId: selectedService,
      };

      const timeout = setTimeout(() => {
        refreshFolderPreview(filterObj);
      }, 0);

      return () => clearTimeout(timeout);
    }

    effectRan.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [folder]);

  useEffect(() => {
    const filterObj = {
      folderUId: folder?.folderUId,
      nameContains,
      serviceId: selectedService,
    };
    refreshFolderPreview(filterObj);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [folder]);

  return (
    <form className={styles.formContainer} onSubmit={(e) => e.preventDefault()}>
      <div className={styles.formGroup}>
        <label htmlFor="folder" className={styles.label}>
          {i18n.t("Mediatheque.Filter.Folder")} :
        </label>
        <input
          type="text"
          id="folder"
          value={folder?.folderName || ""}
          className={styles.input}
          disabled
        />
      </div>

      <div className={styles.formRow}>
        <div className={styles.formGroup}>
          <label htmlFor="name" className={styles.label}>
            {i18n.t("Mediatheque.Filter.Name")} :
          </label>
          <input
            type="text"
            id="name"
            value={nameContains}
            onChange={(e) => setNameContains(e.target.value)}
            className={styles.inputSmall}
          />
        </div>

        <div className={styles.formGroup}>
          <label htmlFor="dropdown" className={styles.label}>
            {i18n.t("Mediatheque.Filter.Service")} :
          </label>
          <select
            id="dropdown"
            value={selectedService}
            onChange={(e) => {
              console.log(e.target.value);
              setSelectedService(e.target.value);
            }}
            className={styles.selectSmall}>
            <option value="00000000-0000-0000-0000-000000000000">
              {i18n.t("Mediatheque.Filter.DropdownService")}
            </option>
            {services.map((option) => (
              <option
                key={option.externalId}
                value={option.externalId}
                className={styles.option}>
                {option.title}
              </option>
            ))}
          </select>
        </div>
      </div>

      <button
        type="button"
        className={styles.filterButton}
        onClick={() => {
          refreshFolderPreview({
            folderUId: folder?.folderUId,
            nameContains,
            serviceId: selectedService,
          });
        }}>
        {i18n.t("Mediatheque.Filter.BtnFilter")}
      </button>
    </form>
  );
};

export default MediaFilter;
